import * as R from 'ramda';
import * as P from 'plow-js';
import { createReducer } from 'redux-act';
// helpers
import * as G from '../../helpers';
// report-common
import { getReportReducers } from '../../report-common';
// feature dispatch-report/load
import * as A from './actions';
//////////////////////////////////////////////////

const {
  initialState,
  setListLoading,
  setInitialState,
  setTableTitleSort,
  setTableTitleFilter,
  resetListAndPagination,
} = getReportReducers({ itemList: {} });

const toggleAuditDetails = (state, data) => P.$toggle(`itemList.${data.index}.expanded`, state);

const getItemListSuccess = (state, data) => {
  const { itemList, pagination } = state;

  const { results, totalCount } = data;

  const indexAdditional = R.length(R.values(itemList));

  const newOffset = R.sum(R.values(pagination));

  const list = R.compose(
    R.mergeRight(itemList),
    R.indexBy(R.prop('index')),
    G.mapIndexed((item, index) => R.mergeRight(
      item,
      {
        expanded: false,
        index: R.add(index, indexAdditional),
        notExpandable: G.isNilOrEmpty(item.changedFields),
      },
    )),
  )(results);

  return P.$all(
    P.$set('itemList', list),
    P.$set('totalCount', totalCount),
    P.$set(
      'pagination.offset',
      G.ifElse(
        R.gt(totalCount, newOffset),
        newOffset,
        totalCount,
      ),
    ),
    state,
  );
};

export default createReducer({
  // report common
  [A.setListLoading]: setListLoading,
  [A.setInitialState]: setInitialState,
  [A.setTableTitleSort]: setTableTitleSort,
  [A.getItemListSuccess]: getItemListSuccess,
  [A.setTableTitleFilter]: setTableTitleFilter,
  [A.resetListAndPagination]: resetListAndPagination,
  //
  [A.toggleAuditDetails]: toggleAuditDetails,
}, initialState);
